import env from "../../config/env";
import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../services/http";
import { ServiceResult } from "../../types/general-types";
import { UserInfoDto } from "./types";
const { API_BASE_URL } = env;

class MyProfileStore {
  static readonly id: string = "MyProfileStore";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async getUserInfos() {
    const result: ServiceResult<UserInfoDto> = await (
      await this.api.get(`/account/get-user-info`)
    ).data;
    return result;
  }
}

export default MyProfileStore;
